import React from 'react';

import Header from "../../Header";

const Contact = ({openBurger, isOpen}) => {
    return (
        <div>
             <Header openBurger={openBurger} isOpen={isOpen} />
        </div>
    );
};

export default Contact;